import { Outlet, NavLink, useLocation } from 'react-router-dom'
import { Calendar, Globe, Bell, User, Clock, Lock, BookOpen } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'
import AddEntryFab from '@/components/ui/AddEntryFab'

const NAV = [
  { to: '/timeline', icon: Calendar, label: 'Timeline' },
  { to: '/discover', icon: Globe, label: 'Discover' },
  { to: '/inform', icon: BookOpen, label: 'Inform' },
  { to: '/capsules', icon: Clock, label: 'Capsules' },
  { to: '/profile', icon: User, label: 'Profile' },
]

export default function AppShell() {
  const location = useLocation()
  const hideNav = ['/timeline/create'].includes(location.pathname)

  return (
    <div className="flex flex-col min-h-dvh bg-bg">
      {/* Page content */}
      <main className="flex-1 overflow-y-auto pb-24">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      {/* FAB */}
      {!hideNav && <AddEntryFab />}

      {/* Bottom nav */}
      {!hideNav && (
        <nav className="fixed bottom-0 inset-x-0 glass safe-bottom z-50">
          <div className="flex items-center justify-around px-2 pt-2 pb-1">
            {NAV.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all
                   ${isActive ? 'text-blue' : 'text-white/30'}`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      size={22}
                      strokeWidth={isActive ? 2.2 : 1.6}
                      className="transition-all"
                    />
                    <span className="text-[9px] font-mono tracking-wider uppercase">
                      {label}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </div>
  )
}
